// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact__QpoCN","logo":"contact_logo__OOfhR","phone":"contact_phone__3-Vqk","address":"contact_address__2lfxC"};